import {
    AnnualMilesVariant,
    useAnnualMilesVariant
} from '../../../../baseDealActivity/baseDealContainer/hooks/useAnnualMilesVariant';
import { CustomMileageNumericRow } from './CustomMileageNumericRow';
import { CustomMileageRow } from './CustomMileageRow';
import { MilesPerYearRow } from './MilesPerYearRow';

const ANNUAL_MILES_ROWS = {
    [AnnualMilesVariant.MILES_PER_YEAR]: MilesPerYearRow,
    [AnnualMilesVariant.CUSTOM_MILEAGE]: CustomMileageRow,
    [AnnualMilesVariant.CUSTOM_MILEAGE_NUMERIC]: CustomMileageNumericRow
};

export const AnnualMilesRow = () => {
    const Row = ANNUAL_MILES_ROWS[useAnnualMilesVariant()];

    return <Row />;
};
